<template>
  <div>
    <div class="form-group">
      <label :for="id" class="d-flex justify-content-between">
        <span>{{ label }}</span>
        <span>
          <slot name="right-label" class=""></slot>
        </span>
      </label>
      <div class="upload-area">
        <div class="upload-area-delete" @click="clearFile()" v-if="fileName && !loading">
          <i class="ri-delete-bin-2-line ri-lg"></i>
        </div>
        <div class="upload-area-error" v-if="error.length > 0">
          {{ error }}
        </div>
        <label :for="id" class="w-100 mb-0">
          <div class="upload-area-content" :class="[!fileName && !loading ? 'no-file' : '', !originalName ? 'no-name' : '']">
            <div class="upload-area-preview" v-if="filePreview">
              <img :src="filePreview" alt="File Preview" />
            </div>
            <div v-if="loading" class="spinner-border text-primary loading-file" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <i class="ri-file-upload-line ri-lg p-2" v-if="!fileName && !loading"></i>
          </div>
        </label>
        <div class="upload-area-label" v-if="originalName.length > 0">
          <span>{{ originalName }}</span>
        </div>
      </div>
    </div>
    <input :value="fileName" type="text" :name="name" style="display: none;">
    <input :id="id" type="file" name="uploadarea" ref="file" @change="onUpload()" style="display: none;" />
    <input type="text" name="file_type" style="display: none;" :value="fileType">
    <input type="text" name="file_ext" style="display: none;" :value="fileExt">
  </div>
</template>

<script>
import Compressor from 'compressorjs';
import { upload } from '../utils/s3';

export default {
  props: {
    id: String,
    name: String,
    label: String,
    myFile: String,
    myFileName: String,
    acceptedTypes: Array,
    isPublic: Boolean,
    document: {
      type: Boolean,
      default: false,
    },
    serverError: String,
  },

  data() {
    return {
      availableFileType: [],
      filePreview: '',
      originalName: '',
      fileName: '',
      error: '',
      submitBtn: '',
      fileType: '',
      fileExt: '',
      loading: false,
      isImage: false,
    }
  },

  methods: {
    onUpload() {
      const file = this.$refs.file.files[0]

      if (file) {
        this.originalName = file.name
        this.loading = true

        if (this.isGoodFileType(file.type)) {
          if (file.size < 50000000) {
            this.fileType = file.type

            if (this.isImage) {
              this.compressFile(file)
                .then((result) => {
                  this.uploadIt(result)
                })
                .catch((err) => {
                  this.onError('Une erreur c\'est produite pendant la compréssion du fichier.')
                })
            } else {
              this.uploadIt(file)
            }
          } else {
            this.onError('Le poids du fichier est trop gros. 50 Mo maximum.')
          }
        } else {
          this.onError('Le fichier doit être une image. jpeg, png, bmp uniquement.')
        }
      }
    },

    uploadIt(file) {
      const self = this
      const fileExtension =  file.name.split('.').pop()
      const fileName = `${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}.${fileExtension}`
      this.fileExt = fileExtension

      upload(file, fileName, this.isPublic, this.document)
        .then((data) => {
          self.fileName = data.Key
          self.error = ''
          self.loading = false

          if (self.isImage) {
            self.filePreview = data.Location
          }
        })
        .catch((err) => {
          if (err) {
            window.bugsnagClient.notify(err)
          }
          this.onError('Une erreur s\'est produite pendant l\'envoi.')
        })
    },

    clearFile() {
      this.$refs.file.value = ''
      this.file = ''
      this.fileUrl = ''
      this.fileName = ''
      this.originalName = ''
      this.filePreview = ''
    },

    onError(msg) {
      this.clearFile()
      this.loading = false
      this.error = msg
    },

    compressFile(file) {
      return new Promise((resolve, reject) => {
        return new Compressor(file, {
          convertSize: 500000,
          success(result) {
            resolve(result)
          },
          error(err) {
            reject(err)
          },
        })
      })
    },

    isGoodFileType(type) {
      if (this.availableFileType.length > 0) {
        return this.availableFileType.indexOf(type) != -1;
      }

      return true;
    },
  },

  mounted() {
    if (this.acceptedTypes) {
      for (let i = 0; i < this.acceptedTypes.length; i++) {
        if (this.acceptedTypes[i] === 'img') {
          this.availableFileType.push('image/jpeg')
          this.availableFileType.push('image/png')
          this.availableFileType.push('image/bmp')

          this.isImage = true
        }
      }
    }

    if (this.serverError) {
      this.error = this.serverError
    }

    if (this.myFile) {
      this.filePreview = this.myFile
    }

    if (this.myFileName) {
      this.fileName = this.myFileName
    }
  }
}
</script>
